module.exports = "/fonts/eppt-logotype-l-68bee74b9d4259ca91449661f4c9bb61.svg";